<template>
  <el-dialog
      class="internationalChannel"
      width="70%"
      title="国际运单"
      :visible.sync="dialogVisible"
      append-to-body
      @close="closeDialog('inner')"
  >
    <el-form
        :model="formInner"
        ref="formInner"
        :rules="formInnerRules"
        class="custom-formItem"
        inline
        label-width="110px"
    >
      <el-form-item label="产品中文" prop="cname">
        <el-input
            placeholder="请输入"
            v-model="formInner.cname"
        ></el-input>
      </el-form-item>
      <el-form-item label="海关品名(英文)" prop="ename">
        <el-input
            placeholder="请输入"
            v-model="formInner.ename"
        ></el-input>
      </el-form-item>
      <el-form-item label="海关编号(HS)" prop="hscode">
        <template slot="label">
          <el-link
              type="primary"
              @click="toOutPage"
              :underline="false"
          >海关编号(HS)
          </el-link
          >
        </template>
        <el-input
            placeholder="请输入6-10位的数字"
            v-model.trim="formInner.hscode"
            onkeyup="value=value.replace(/[^\d.]/g,'')"
        ></el-input>
      </el-form-item>
      <el-form-item label="申报数量" prop="quantity">
        <el-input
            placeholder="请输入"
            v-model="formInner.quantity"
            @keyup.native="number"
        ></el-input>
      </el-form-item>
      <el-form-item label="申报单价" prop="unitPrice">
        <el-input
            placeholder="请输入"
            v-model="formInner.unitPrice"
            @keyup.native="number"
        ></el-input>
      </el-form-item>
      <el-form-item label="申报总值" prop="goodDeclareWorth">
        <el-input
            placeholder="请输入"
            v-model="formInner.goodDeclareWorth"
        ></el-input>
      </el-form-item>
      <el-form-item label="申报重量" prop="goodsWeight">
        <el-input
            placeholder="请输入"
            v-model="formInner.goodsWeight"
        ></el-input>
      </el-form-item>
      <el-form-item label="申报体积" required>
        <el-row type="flex" justify="space-between" align="middle">
          <el-form-item prop="goodsLength" class="w100">
            <el-input
                placeholder="长"
                v-model="formInner.goodsLength"
            ></el-input>
          </el-form-item>
          <div style="padding:0 10px;">X</div>
          <el-form-item prop="goodsWidth" class="w100">
            <el-input
                placeholder="宽"
                v-model="formInner.goodsWidth"
            ></el-input>
          </el-form-item>
          <div style="padding:0 10px;">X</div>
          <el-form-item prop="goodsHeight" class="w100">
            <el-input
                placeholder="高"
                v-model="formInner.goodsHeight"
            ></el-input>
          </el-form-item>
        </el-row>
      </el-form-item>
      <el-form-item v-if="BatchSel" prop="currencyCode" label="币种选择">
        <el-select
            @change="EuropeChange"
            :disabled="Europe"
            v-model="formInner.currencyCode"
        >
          <el-option
              v-for="(item, i) in currencyL"
              :key="i"
              :label="item"
              :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="BatchSel" prop="containsBattery" label="是否带电">
        <template>
          <el-radio v-model="formInner.containsBattery" label="false">否</el-radio>
          <el-radio v-model="formInner.containsBattery" label="true">是</el-radio>
        </template>
      </el-form-item>
      <!-- currencyL -->
      <el-form-item label="税号" prop="vatNumber">
        <el-input
            disabled
            placeholder=""
            v-model="formInner.vatNumber"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="销售链接" prop="productUrl">
        <el-input placeholder="请输入" v-model="formInner.productUrl" readonly></el-input>
      </el-form-item>-->
      <el-form-item label="物流" required style="width: 50%;">
        <el-row type="flex" align="middle">
          <el-form-item
              prop="type"
              class="w100"
              style="margin-right: 10px;"
          >
            <el-select
                v-model="formInner.type"
                @change="selectChange"
                filterable
                value-key="itemTypeId"
            >
              <el-option
                  v-for="item in listLogistics"
                  :key="item.id"
                  :label="item.itemTypeName"
                  :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
              prop="shippingMethod"
              class="w100"
              style="margin-right: 10px;"
          >
            <el-select
                v-model="formInner.shippingMethod"
                filterable
                value-key="value"
                @change="selectChange($event, 'channel')"
            >
              <el-option
                  v-for="item in logisticsTwoList"
                  :key="item.id"
                  :label="item.title"
                  :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-button
              type="primary"
              @click="createWaybill"
              :loading="loadingCreateWaybill"
              v-show="isVisible"
          >生成运单
          </el-button
          >
        </el-row>
      </el-form-item>
      <!-- <el-form-item label="申报SKU" prop="sku" style="width: 50%;">
        <el-row type="flex" align="middle">
          <el-button
              type="primary"
              @click="selectRecordSKU"
              style="margin-right: 10px;"
          >备案SKU
          </el-button
          >
          <el-input
              :readonly="true"
              v-model="formInner.sku"
          ></el-input>
        </el-row>
      </el-form-item> -->

      <el-form-item label="运单" v-show="isVisible">
        <el-input readonly v-model="conveyNumber"></el-input>
      </el-form-item>
      <el-form-item label="追踪" v-show="isVisible">
        <el-input readonly v-model="trackNumber"></el-input>
      </el-form-item>
      <el-form-item v-if="formInner.channel" label="订单渠道" style="width: 430px;">
        <el-input
            disabled
            placeholder=""
            v-model="formInner.channel"
        ></el-input>
      </el-form-item>
       <el-form-item v-if="formInner.logisticsType" label="客户物流方式" prop="vatNumber" style="width: 430px;">
        <el-input
            disabled
            placeholder=""
            v-model="formInner.logisticsType"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="formInner.logisticsServiceName" label="物流服务名称" prop="vatNumber" style="width: 430px;">
        <el-input
            disabled
            placeholder=""
            v-model="formInner.logisticsServiceName"
        ></el-input>
      </el-form-item>
    </el-form>

    <template slot="footer">
      <el-button type="primary" @click="submitDone" :loading="loadingDone"
      >完 成
      </el-button
      >
    </template>

    <el-dialog
        title="选择备案SKU"
        append-to-body
        :visible.sync="dialogVisibleThird"
    >
      <el-table :data="listDialogTable" border style="width: 100%">
        <el-table-column
            prop="sku"
            label="SKU"
            align="center"
        ></el-table-column>
        <el-table-column label="申报品名" align="center">
          <template slot-scope="scope">
            <div>英文：{{ scope.row.englishName }}</div>
            <div>中文：{{ scope.row.chinaName }}</div>
          </template>
        </el-table-column>
        <el-table-column label="图片" width="200" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.productImages">
              <el-popover
                  trigger="hover"
                  placement="right"
                  prop="orderItems.imageUrl"
                  v-if="scope.row.productImages[0]"
              >
                <el-image
                    style="width: 500px;height: 500px;"
                    :src="scope.row.productImages[0]"
                />
                <div class="scope_img" slot="reference">
                  <el-image
                      :src="scope.row.productImages[0]"
                  />
                </div>
              </el-popover>
              <!-- <el-button
                  type="text"
                  size="mini"
                  v-else
                  @click="getOriginalImg(item)"
                  style="padding: 0;"
              >查看原图</el-button>-->
            </div>
          </template>
        </el-table-column>
        <el-table-column label="海关审核状态" align="center">
          <template slot-scope="scope">
            <div
                style="width: 130px;text-align: left;margin: 0 auto;"
            >
              <span>北美：</span>
              <span v-if="scope.row.naStatus === 0">待审核</span>
              <span
                  v-else-if="scope.row.naStatus === 1"
                  :style="{
									color:
										scope.row.naStatus === 1 ? 'green' : '',
								}"
              >审核通过</span
              >
              <span
                  v-else-if="scope.row.naStatus === 2"
                  :style="{
									color:
										scope.row.naStatus === 2 ? 'red' : '',
								}"
              >审核不予通过</span
              >
            </div>
            <div
                style="width: 130px;text-align: left;margin: 0 auto;"
            >
              <span>欧洲：</span>
              <span v-if="scope.row.eurStatus === 0">待审核</span>
              <span
                  v-else-if="scope.row.eurStatus === 1"
                  :style="{
									color:
										scope.row.eurStatus === 1
											? 'green'
											: '',
								}"
              >审核通过</span
              >
              <span
                  v-else-if="scope.row.eurStatus === 2"
                  :style="{
									color:
										scope.row.eurStatus === 2 ? 'red' : '',
								}"
              >审核不予通过</span
              >
            </div>
            <div
                style="width: 130px;text-align: left;margin: 0 auto;"
            >
              <span>中国：</span>
              <span v-if="scope.row.zhStatus === 0">待审核</span>
              <span
                  v-else-if="scope.row.zhStatus === 1"
                  :style="{
									color:
										scope.row.zhStatus === 1 ? 'green' : '',
								}"
              >审核通过</span
              >
              <span
                  v-else-if="scope.row.zhStatus === 2"
                  :style="{
									color:
										scope.row.zhStatus === 2 ? 'red' : '',
								}"
              >审核不予通过</span
              >
            </div>
            <div
                style="width: 130px;text-align: left;margin: 0 auto;"
            >
              <span>日本：</span>
              <span v-if="scope.row.jpStatus === 0">待审核</span>
              <span
                  v-else-if="scope.row.jpStatus === 1"
                  :style="{
									color:
										scope.row.jpStatus === 1 ? 'green' : '',
								}"
              >审核通过</span
              >
              <span
                  v-else-if="scope.row.jpStatus === 2"
                  :style="{
									color:
										scope.row.jpStatus === 2 ? 'red' : '',
								}"
              >审核不予通过</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button
                type="primary"
                @click="checkedRecordSKU(scope.row)"
            >选择
            </el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-row
          type="flex"
          justify="center"
          align="middle"
          style="margin-top: 20px;"
      >
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageDialog"
            :page-sizes="[10, 20, 50, 100, 200, 300]"
            :page-size="sizeDialog"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalDialog"
        ></el-pagination>
      </el-row>
    </el-dialog>
  </el-dialog>
</template>

<script>
import {ajaxPost, Baseurl} from '@/api/api/api'
import listCountryPrice from './listCountryPrice'

export default {
  name: 'InternationalChannel',
  data() {
    return {
      Europe: false,
      BatchSel: true,
      BatchCurrency: ['USD', 'EUR'],
      currencyL: [
        'GBP',
        'EUR',
        'USD',
        'CAD',
        'MXN',
        'JPY',
        'AUD',
        'AED',
        'SGD',
        'INR',
        'SEK',
        'PLN',
        'SAR',
      ],

      infoData: {},
      dialogVisible: false,
      listLogistics: [],
      EuropeList: [],
      //当前默认汇率
      parities: 0,
      formInner: {
        type: '',
        shippingMethod: '',
        currencyCode: '',
        containsBattery: 'false',
        cname: '',
        ename: '',
        hscode: '',
        quantity: '1',
        unitPrice: '',
        goodDeclareWorth: '1',
        goodsWeight: '1',
        goodsLength: '1',
        goodsWidth: '1',
        goodsHeight: '1',
        productUrl: '',
        vatNumber: '',
        sku: '',
        channel: '',
        logisticsType: '',
        logisticsServiceName: '',
      },
      formInnerRules: {
        type: [
          {
            required: true,
            message: '物流选择有误',
            trigger: 'change',
          },
        ],
        shippingMethod: [
          {
            required: true,
            message: '物流选择有误',
            trigger: 'change',
          },
        ],
        cname: [
          {
            required: true,
            message: '产品中文输入有误',
            trigger: 'blur',
          },
        ],
        ename: [
          {
            required: true,
            message: '海关品名(英文)输入有误',
            trigger: 'blur',
          },
        ],
        hscode: [
          {
            required: true,
            message: '海关编号(HS)输入有误',
            trigger: 'blur',
          },
        ],
        quantity: [
          {
            required: true,
            message: '申报数量输入有误',
            trigger: 'blur',
          },
        ],
        unitPrice: [
          {
            required: true,
            message: '申报单价输入有误',
            trigger: 'blur',
          },
        ],
        // goodDeclareWorth: [{ required: true, message: "申报总值输入有误", trigger: "blur" }],
        goodsWeight: [
          {
            required: true,
            message: '申报重量输入有误',
            trigger: 'blur',
          },
        ],
        goodsLength: [
          {
            required: true,
            message: '长度输入有误',
            trigger: 'blur',
          },
        ],
        goodsWidth: [
          {
            required: true,
            message: '宽度输入有误',
            trigger: 'blur',
          },
        ],
        goodsHeight: [
          {
            required: true,
            message: '高度输入有误',
            trigger: 'blur',
          },
        ],
        productUrl: [
          {
            required: true,
            message: '销售链接输入有误',
            trigger: 'blur',
          },
        ],
        // sku: [{ required: true, message: "sku有误", trigger: "blur" }],
      },
      loadingCreateWaybill: false,
      loadingDone: false,

      logisticsTwoList: [],

      dialogVisibleThird: false,
      pageDialog: 1,
      sizeDialog: 20,
      totalDialog: 0,
      listDialogTable: [],
      conveyNumber: '',
      trackNumber: '',
      conveyNumberUrl: '',

      batchOrders: [],
      roleId: '',
      isVisible: true,
      transferOrderNumber: '',
      channelWayEn: '',
      order_Id: ''
    }
  },
  computed: {
    infoAddress() {
      return this.infoData.address || {}
    },
    goodDeclareWorth() {
      return (this.formInner.quantity * this.formInner.unitPrice).toFixed(2) < 130 ? (this.formInner.quantity * this.formInner.unitPrice).toFixed(2) : 130;
    },
  },
  methods: {
    number() {
      this.formInner.quantity = this.formInner.quantity.replace(/[^\.\d]/g, '');
      this.formInner.quantity = this.formInner.quantity.replace('.', '');
      this.formInner.goodDeclareWorth = (this.formInner.quantity * this.formInner.unitPrice).toFixed(2) < 130 ? (this.formInner.quantity * this.formInner.unitPrice).toFixed(2) : 130;
    },
    EuropeChange(item) {
      // currencyCode
      let obj = this.EuropeList.filter((otem) => {
        return item == otem.currencyCode
      })
      // console.log(obj[0].exchangeRate)
      this.formInner.unitPrice = (
          (this.parities / obj[0].exchangeRate) *
          this.infoData.orderItems[0].itemAmount
      ).toFixed(2)
      this.formInner.goodDeclareWorth = (this.formInner.quantity * this.formInner.unitPrice).toFixed(2) < 130 ? (this.formInner.quantity * this.formInner.unitPrice).toFixed(2) : 130;
      // console.log(this.formInner.unitPrice)
    },
    initComponents(data) {
      this.BatchSel = true
      this.infoData = data.infoData
      this.roleId = data.roleId
      this.formInner.channel = this.infoData.orderItems[0].channel
      this.formInner.logisticsType = this.infoData.orderItems[0].logisticsType
      this.formInner.logisticsServiceName = this.infoData.orderItems[0].logisticsServiceName
      // console.log(JSON.parse(JSON.stringify(this.infoData)))
      let API = Baseurl + 'rateController/getRate'
      ajaxPost(API, {}).then((res) => {
        // console.log(JSON.parse(JSON.stringify(res.data.data)))
        if (res.data.code == 200) {
          this.EuropeList = res.data.data
          let pbj = res.data.data.filter((item) => {
            return (
                this.infoData.orderItems[0].itemCurrencyCode ==
                item.currencyCode
            )
          })
          // parities
          this.parities = pbj[0].exchangeRate
          // console.log(this.parities)
        }
      })
      this.getOrderMoney()
          .then((code) => {
            if (code === 200) {
              this.getLogisticsList()
              // console.log(
              // 	listCountryPrice[this.infoData.address.countryCode1]
              // )
              if (
                  listCountryPrice[
                      this.infoData.address.countryCode1
                      ] === '17'
              ) {
                this.Europe = false
                this.formInner.currencyCode = this.infoData.orderItems[0].itemCurrencyCode
                this.formInner.unitPrice =
                    (this.infoData.orderItems[0].itemAmount *
                        (this.parities / this.EuropeList[6].exchangeRate)).toFixed(2)
                this.formInner.currencyCode = 'USD'
              } else {
                this.Europe = true
                this.formInner.currencyCode = 'USD'
                this.formInner.unitPrice =
                    listCountryPrice[
                        this.infoData.address.countryCode1
                        ] || '17'
              }
              if(this.infoData.source === 14){
                    console.log("速卖通");
                    console.log(this.EuropeList);
                    this.formInner.unitPrice = (this.infoData.orderItems[0].itemAmount * (this.parities / this.EuropeList[6].exchangeRate) / 10).toFixed(2)
              }
              this.formInner.goodDeclareWorth = this.formInner.quantity * this.formInner.unitPrice < 130 ? (this.formInner.quantity * this.formInner.unitPrice).toFixed(2) : 130;
              this.formInner.productUrl = this.infoData.orderItems[0].saleLink
              // this.formInner.sku = this.infoData.orderItems[0].sellerSKU;
              this.formInner.sku = ''
              this.formInner.vatNumber = this.infoData.vatNumber

              // this.formInner.goodDeclareWorth = this.formInner.unitPrice * this.formInner.quantity;
              this.dialogVisible = true
            }
          })
          .catch((err) => {
            this.$message.error(err || '网络出现问题，请稍候')
          })
    },
    initComponents2(data) {
      this.BatchSel = false
      this.getLogisticsList()
      this.formInner.sku = ''
      this.formInner.unitPrice = '35'
      this.formInner.goodDeclareWorth =
          this.formInner.unitPrice * this.formInner.quantity
      this.dialogVisible = true

      this.batchOrders = data.checkedOrders
      this.roleId = data.roleId
      this.isVisible = false
      // this.formInner.currencyCode = 'USD'
    },
    closeDialog() {
      if (this.batchOrders.length) {
        this.batchOrders = []
        this.isVisible = true
        this.$emit('close2')
      } else {
        this.formInner = this.$options.data().formInner
        this.$refs.formInner.clearValidate()
        this.$emit('close')
      }
    },
    toOutPage() {
      window.open('https://www.hsbianma.com/')
    },
    getOrderMoney() {
      return new Promise((resolve, reject) => {
        const API =
            Baseurl + 'logisticsController/selectCompanyBalanceByOrder'
        const paramsData = {orderId: this.infoData.orderId}
        ajaxPost(API, paramsData).then((res) => {
          const {code, data} = res.data
          if (code === 200) {
            resolve(code)
          } else {
            reject(data)
          }
        })
      })
    },
    // 获取物流列表
    getLogisticsList() {
      const API = Baseurl + 'purchaseController/selectItemList'
      const paramsData = {
        itemCode: 'HYXUN0000007',
      }
      ajaxPost(API, paramsData).then((res) => {
        const {code, data} = res.data
        if (code === 200) {
          this.listLogistics = data
        }
      })
    },
    handleSizeChange(val) {
      this.sizeDialog = val
      this.selectRecordSKU()
    },
    handleCurrentChange(val) {
      this.pageDialog = val
      this.selectRecordSKU()
    },
    selectRecordSKU() {
      const API = Baseurl + 'recordSkuController/selectRecordSkuList'
      const paramsData = {
        page: this.pageDialog,
        size: this.sizeDialog,
        searchString: '',
      }
      ajaxPost(API, paramsData).then((res) => {
        const {code, data} = res.data
        if (code === 200) {
          this.dialogVisibleThird = true
          this.listDialogTable = data.list
          this.totalDialog = data.total
        }
      })
    },
    checkedRecordSKU(row) {
      this.formInner.sku = row.sku
      this.dialogVisibleThird = false
    },
    selectChange(item, selectType) {
      console.log(item)
      this.conveyNumber = ''
      this.trackNumber = ''
      if (selectType === 'channel') {
        this.channelWayEn = item.ename
        return
      }
      this.formInner.shippingMethod = ''
      const {itemTypeId: type} = item
      const API = Baseurl + 'logisticsController/getShippingMethodList'
      console.log(this.formInner);
      const paramsData = {
        type: type,
        onlineLogisticsServiceParam: {
              sellerId: this.infoData.sellerId,
              order_id: this.infoData.amazonOrderId,
              goods_length: this.formInner.goodsLength,
              goods_weight: this.formInner.goodsWeight,
              goods_height: this.formInner.goodsHeight,
              goods_width: this.formInner.goodsWidth
            },
      }
      ajaxPost(API, paramsData).then((res) => {
        const {code, data} = res.data
        if (code === 200) {
          let itemTitleKey = ''
          let itemTitleKey1 = ''
          let itemValueKey = ''
          let itemEnKey = ''
          if (type === '1') {
            itemTitleKey = 'cnName'
            itemValueKey = 'methodCode'
            itemEnKey = 'enName'
          } else if (type === '2') {
            itemTitleKey = 'cname'
            itemValueKey = 'code'
            itemEnKey = 'ename'
          } else if (type === '3') {
            itemTitleKey = 'name'
            itemValueKey = 'id'
            itemEnKey = 'nameEn'
          } else if (type === '5') {
            itemTitleKey = 'cnName'
            itemValueKey = 'code'
            itemEnKey = 'enName'
          } else if (type === '6' || type === '11') {
            itemTitleKey = 'logistics_product_name_cn'
            itemValueKey = 'logistics_product_code'
            itemEnKey = 'logistics_product_name_en'
          } else if (type === '7') {
            itemTitleKey = 'cname'
            itemValueKey = 'code'
            itemEnKey = 'ename'
          } else if (type === '8') {
            itemTitleKey = 'channelName'
            itemValueKey = 'channelId'
            itemEnKey = ''
          } else if (type === '9') {
            itemTitleKey = 'shipName'
            itemValueKey = 'shipCode'
            itemEnKey = ''
          } else if (type === '10') {
            itemTitleKey = 'cname'
            itemValueKey = 'code'
            itemEnKey = 'ename'
          } else if (type === '12' || type === '13' || type === '17' || type === '20' || type === '21' || type === '24' || type === '25' || type === '26' || type === '27' || type === '28' || type === '30' || type === '31') {
            itemTitleKey = 'productShortname'
            itemValueKey = 'productId'
            itemEnKey = ''
          } else if (type === '14') {
            itemTitleKey = 'shippingMethodCnName'
            itemValueKey = 'shippingMethodCode'
            itemEnKey = 'shippingMethodEnName'
          } else if (type === '18') {
            itemTitleKey = 'productName'
            itemValueKey = 'productName'
            itemEnKey = ''
          } else if (type === '19') {
            itemTitleKey = 'cnName'
            itemValueKey = 'code'
            itemEnKey = 'enName'
          } else if (type === '22') {
            itemTitleKey = 'routeName'
            itemValueKey = 'routeId'
            itemEnKey = ''
          } else if (type === '23') {
            itemTitleKey = 'lineName'
            itemValueKey = 'lineCode'
            itemEnKey = ''
          } else if (type === '29') {
            itemTitleKey = 'serviceName'
            itemValueKey = 'serviceCode'
            itemEnKey = ''
          } else if (type === '32') {
            itemTitleKey = 'logistics_service_name'
            itemTitleKey1 = 'warehouse_name'
            itemValueKey = 'logistics_service_id'
            itemEnKey = 'logistics_service_id'
          } else if (type === '34') {
            itemTitleKey = 'productExplain'
            itemValueKey = 'productCode'
            itemEnKey = ''
          }else if(type === '35'){
            itemTitleKey = 'cname'
            itemValueKey = 'code'
            itemEnKey = 'ename'
          }
          if (!itemTitleKey) return
          this.logisticsTwoList = []

          data.forEach((item) => {
            // console.log(item)
            const itemObj = {
              id: item.id || item.ytId,
              title: item[itemTitleKey] + (item[itemTitleKey1] ? ' / ' + item[itemTitleKey1] : ''),
              value: item[itemValueKey],
              ename: item[itemEnKey],
            }
            this.logisticsTwoList.push(itemObj)
          })
        }
      })
    },

    createWaybill() {
      if (!this.infoAddress.phone) {
        this.$message.error('缺少TEL')
        return
      }
      if (this.infoAddress.name.length > 50) {
        this.$message.error('收件人姓名太长')
      } else {
        this.$refs.formInner.validate((valid) => {
          if (!valid) return
          const API =
              Baseurl + 'logisticsController/applyConveyNumber'
          const {itemTypeId} = this.formInner.type
          // console.log(JSON.parse(JSON.stringify(this.infoData)))
          const paramsData = {
            customerOrderNumber: this.infoData.customerOrderNo,
            orderId: this.infoData.id,
            amazonOrderId: this.infoData.amazonOrderId,
            sellerId: this.infoData.sellerId,
            // vatNumber: this.formInner.vatNumber,
            memo: '',
            type: itemTypeId,
            shippingMethod: this.formInner.shippingMethod.value,
            applyFromStatus: 1,
            receiver: {
              countryCode: this.infoAddress.countryCode1,
              countryName: this.infoAddress.countryCode,
              firstName: this.infoAddress.name,
              lastName: this.infoAddress.name,
              company: '',
              street: '',
              city: this.infoAddress.city || '',
              state: this.infoAddress.stateOrRegion || '',
              phone: this.infoAddress.phone,
              houseNumber: '',
              email: this.infoData.buyerEmail,
              streetAddress1: this.infoAddress.addressLine1 || '',
              streetAddress2: this.infoAddress.addressLine2 || '',
              streetAddress3: this.infoAddress.addressLine3 || '',
              postcode: this.infoAddress.postalCode,
            },
            sender: {
              countryCode: this.infoData.countryMark,
              firstName: this.infoData.buyerName,
              lastName: this.infoData.buyerName,
              company: '',
              street: '',
              city: '',
              state: '',
              zip: '',
              phone: '',
              houseNumber: '',
            },
            parcels: {
              // sku: this.infoData.orderItems[0].sellerSKU,
              childOrderIdList: this.infoData.orderItems.map(item => item.childOrderId),
              productIdList: this.infoData.orderItems.map(item => item.sellerSKU),
              invoiceRemark: '',
              currencyCode: this.formInner.currencyCode,
              boxWeight: '',
              unitWeight: '1',
              ...this.formInner,
              goodDeclareWorth: this.goodDeclareWorth,
            },
          }
          // 判断州 市是否有值，没有的话就互相赋值
          if (
              !paramsData.receiver.city ||
              !paramsData.receiver.state
          ) {
            if (!paramsData.receiver.city) {
              paramsData.receiver.city = paramsData.receiver.state
            }
            if (!paramsData.receiver.state) {
              paramsData.receiver.state = paramsData.receiver.city
            }
          }
          if (itemTypeId === '3')
            paramsData.shippingMethod = this.formInner.shippingMethod.id
          // paramsData.shippingMethod =
          this.loadingCreateWaybill = true
          ajaxPost(API, paramsData).then((res) => {
            const {code, data} = res.data
            console.log(data)
            this.loadingCreateWaybill = false
            if (code === 200) {
              try {
                // 1 三态 2 云途 3 燕文 5 k5
                if (itemTypeId === '1') {
                  this.conveyNumber = data.orderCode
                  this.trackNumber = data.trackingNumber
                  this.channelId = data.orderChannelId
                  this.transferOrderNumber =
                      data.trackingNumberUsps
                } else if (itemTypeId === '2') {
                  this.conveyNumber =
                      data.item[0].wayBillNumber
                  this.trackNumber =
                      data.item[0].trackingNumber
                  this.channelId = data.item[0].orderChannelId
                } else if (itemTypeId === '3') {
                  this.conveyNumber = data.data.waybillNumber
                  this.trackNumber = ''
                  this.channelId = data.orderChannelId
                  this.transferOrderNumber = data.data.referenceNumber
                } else if (itemTypeId === '5') {
                  this.conveyNumber =
                      data.returnDatas[0].corpBillid
                  this.trackNumber =
                      data.returnDatas[0].trackNumber
                  this.channelId =
                      data.returnDatas[0].customerNumber
                } else if (
                    itemTypeId === '6' ||
                    itemTypeId === '11'
                ) {
                  this.conveyNumber =
                      data.data.logistics_channel_no
                  this.trackNumber = data.data.px_tracking_no
                  this.channelId = data.data.ref_no
                } else if (itemTypeId === '7') {
                  this.conveyNumber =
                      data.item[0].wayBillNumber
                  this.trackNumber =
                      data.item[0].trackingNumber
                  this.channelId = data.item[0].orderChannelId
                } else if (itemTypeId === '8') {
                  this.conveyNumber = data.billid
                  this.trackNumber = data.corpbillid
                  this.channelId = data.refernumb
                } else if (itemTypeId === '9') {
                  this.conveyNumber = data.trackingNo
                  this.trackNumber = data.vsnumber
                  this.channelId = data.refNo
                } else if (itemTypeId === '10') {
                  this.conveyNumber =
                      data.item[0].wayBillNumber
                  this.trackNumber =
                      data.item[0].trackingNumber
                  this.channelId = data.item[0].orderChannelId
                } else if (itemTypeId === '12' || itemTypeId === '13' || itemTypeId === '17' || itemTypeId === '20' || itemTypeId === '21' || itemTypeId === '24' || itemTypeId === '25' || itemTypeId === '26' || itemTypeId === '30') {
                  this.conveyNumber = data.tracking_number
                  this.trackNumber = ''
                  this.channelId = data.reference_number
                  this.order_Id = data.order_id
                } else if (itemTypeId === '14'){
                  this.conveyNumber = data.data.waybillNumber
                  this.trackNumber = data.data.trackingNumber
                  this.channelId = data.data.referenceNumber
                } else if (itemTypeId === '19'){
                  this.conveyNumber = data.order_code
                  this.trackNumber = ''
                  this.channelId = data.reference_no
                } else if (itemTypeId === '22'){
                  this.conveyNumber = data.mailno
                  this.trackNumber = ''
                  this.channelId = data.txlogisticid
                } else if (itemTypeId === '23'){
                  this.conveyNumber = data.logisticsNo
                  this.trackNumber = ''
                  this.channelId = data.orderNo
                  this.transferOrderNumber = data.agentNo
                } else if (itemTypeId === '27') {
                  this.conveyNumber = data.data.orderNo
                  this.trackNumber = ''
                  this.channelId = data.data.outOrderNo
                  this.conveyNumberUrl = data.data.orderLabelUrl
                } else if (itemTypeId === '28' || itemTypeId === '31') {
                  this.conveyNumber = data.orderCode
                  this.trackNumber = data.trackingNumber
                  this.channelId = data.orderChannelId
                } else if (itemTypeId === '29') {
                  this.conveyNumber = data.Data.tracking_number
                  this.trackNumber = ''
                  this.channelId = data.Data.ref_number
                  this.conveyNumberUrl = data.Data.label
                } else if (itemTypeId === '32') {
                  this.conveyNumber = data.international_logistics_num
                  this.trackNumber = ''
                  this.channelId = data.orderChannelId
                } else if (itemTypeId === '34') {
                  this.conveyNumber = data.expressNumber
                  this.trackNumber = ''
                  this.channelId = data.customerNumber
                }else if(itemTypeId === '35'){
                  this.conveyNumber = data.waybillNo;
                  this.channelId = data.customerOrderNo;
                  this.trackNumber = '';
                }
                //  else if (itemTypeId === '18'){
                //   this.conveyNumber = data.data.waybillNumber
                //   this.trackNumber = data.data.trackingNumber
                //   this.channelId = data.data.referenceNumber
                // }
                this.applyFromStatus = data.applyFromStatus
                this.isCreateWaybill = true
                this.$message.success('操作成功')
              } catch (error) {
                console.log(error)
                if (itemTypeId === '3') {
                  this.$message.error(data.message)
                } else {
                  this.$message.error('生成超时')
                }
              }
            } else if (code === 500) {
              if (itemTypeId === '3') {
                this.$message.warning(data.message)
                return
              }
              this.$message.warning(data)
            } else {
              this.$message.warning(data)
            }
          })
        })
      }
    },
    addWaybillDone() {
      // this.$refs.infoAddress.validate(valida => {
      //     if (!valida) return;
      if (this.isReceiverEdit) {
        this.$message.warning('请先完成收件人信息！')
        return
      }
      if (!this.isCreateWaybill) {
        this.$message.warning('请先生成运单！')
        return
      }
      if (!this.conveyNumber) {
        this.$message.warning('运单号有误！')
        return
      }
      const API = Baseurl + 'logisticsController/insertOrderChannel'
      const {
        type: {itemTypeName: channelName, itemTypeId: type},
        shippingMethod: {title: channelWay},
        cname: productChineseName,
        ename: productEnglishName,
        hscode: customsNo,
        quantity: applyCount,
        unitPrice: applyPrice,
        goodDeclareWorth: applyTotal,
        goodsWeight: applyWeight,
        productUrl: sellLink,
        goodsLength,
        goodsWidth,
        goodsHeight,
      } = this.formInner
      const applyVolume =
          Number(goodsLength) * Number(goodsWidth) * Number(goodsHeight)
      const paramsData = {
        channelWayEn: this.channelWayEn,
        roleId: this.roleId,
        companyId: this.infoData.company_id,
        orderId: this.infoData.id,
        channelName,
        channelWay,
        type,
        productChineseName,
        productEnglishName,
        customsNo,
        applyCount,
        applyPrice,
        applyTotal,
        applyWeight,
        applyVolume,
        sellLink,
        conveyNumber: this.conveyNumber,
        trackNumber: this.trackNumber,
        actualWeight: '',
        status: '0',
        orderChannelId: this.channelId,
        channelId: this.order_Id,
        destinationCountryMark: this.infoData.address.countryCode1,
        applyFromStatus: this.applyFromStatus,
        transferOrderNumber: this.transferOrderNumber,
        conveyNumberUrl: this.conveyNumberUrl,
      }
      // console.log(this.transferOrderNumber)
      this.loadingDone = true
      ajaxPost(API, paramsData).then((res) => {
        const {code} = res.data
        this.loadingDone = false
        if (code === 200) {
          this.$message.success('操作成功')
          this.dialogVisible = false
          this.conveyNumber = ''
          this.trackNumber = ''
          // this.getInfo();
          this.$emit('refreshData')
        } else {
          this.$message.warning('操作失败')
        }
      })
      // });
    },
    batchAddWaybillDone() {
      let R = /^[0-9]{6,10}$/
      if (!R.test(this.formInner.hscode)) {
        this.$message.warning('输入的海关编号不符合规则，请重输！')
        return
      }

      const API = Baseurl + 'channelTaskController/batchAddChannelTask'
      // console.log(this.batchOrders)
      const channelTasks = this.batchOrders.map((item) => {
        return {
          orderId: item.id,
          // vatNumber: item.vatNumber,
          amazonOrderId: item.amazonOrderId,
          companyId: item.companyId,
          channelType: this.formInner.type.itemTypeId,
          channelWay: this.formInner.shippingMethod.value,
          chineseChannelWay: this.formInner.shippingMethod.title,
          channelName: this.formInner.type.itemTypeName,
          productChineseName: this.formInner.cname,
          productEnglishName: this.formInner.ename,
          customsNo: this.formInner.hscode,
          applyCount: this.formInner.quantity,
          applyPrice: this.formInner.unitPrice,
          applyTotal: this.goodDeclareWorth,
          applyWeight: this.formInner.goodsWeight,
          applyLength: this.formInner.goodsLength,
          applyWidth: this.formInner.goodsWidth,
          applyHeight: this.formInner.goodsHeight,
          applySku: this.formInner.sku,
          roleId: this.roleId,
          englishChannelWay: this.channelWayEn,
        }
      })
      const paramsData = {channelTasks}

      this.loadingDone = true
      ajaxPost(API, paramsData).then((res) => {
        const {code} = res.data
        this.loadingDone = false
        if (code === 200) {
          this.$message.success('操作成功')
          this.dialogVisible = false
        } else {
          this.$message.warning('操作失败')
        }
      })
    },
    submitDone() {
      if (this.batchOrders.length) {
        this.batchAddWaybillDone()
      } else {
        this.addWaybillDone()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.internationalChannel {
  .custom-formItem {
    ::v-deep {
      .el-form-item {
        width: 25%;
        margin-right: 0;
      }

      .el-form-item__content {
        width: calc(100% - 120px);

        .el-select,
        .el-date-editor,
        .el-input {
          width: 100%;
        }
      }

      .w100 {
        width: 100%;

        .el-form-item__content {
          width: 100%;
        }
      }
    }
  }
}
</style>
